"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTopTimeout = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
exports.scrollTopTimeout = function () {
    setTimeout(function () {
        window.scroll(0, 0);
    }, 0);
};
function CarCard(props) {
    var children = props.children;
    react_1.useEffect(function () {
        exports.scrollTopTimeout();
    }, []);
    return (react_1.default.createElement("div", { className: "azgazui__card" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" }, children))));
}
exports.default = CarCard;
CarCard.displayName = 'CarCard';
CarCard.propTypes = {
    children: prop_types_1.default.arrayOf(prop_types_1.default.node).isRequired,
};
